import { apiConfig } from "core-lib/config/config";
import { postMethod } from "core-lib/utils/apiV2";
import { isStringValid } from "core-lib/utils/utils";

type ResultTypes = {
  response?: string;
  error?: any;
};

export const uploadFile = async ({
  file,
  serviceName = "parkplus-dashboard",
  convertTo,
}: {
  file: any;
  serviceName?: string;
  convertTo?: string;
}): Promise<ResultTypes> => {
  if (file) {
    const { name, type } = file;
    const lastDot = name.lastIndexOf(".");
    const fileName = name.substring(0, lastDot);
    const ext = name.substring(lastDot + 1);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("doc_name", fileName);
    formData.append("service_name", serviceName);
    formData.append("extension", ext);
    formData.append("doc_type", type.split("/")[0]);
    formData.append("is_public", "true");
    formData.append("is_view_only", "true");

    if (isStringValid(convertTo)) formData?.append("convert_to", convertTo);

    const { response, error }: any = await postMethod({
      endPoint: `${apiConfig("storage", "v1")}/document/upload/`,
      body: formData,
    });
    if (response?.key) {
      return { response: response?.key };
    } else {
      return { error };
    }
  } else {
    return {
      error: {
        message: "No file selected",
      },
    };
  }
};

export default uploadFile;
